import script from "./TasksModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksModal.vue?vue&type=script&setup=true&lang=js"

import "./TasksModal.vue?vue&type=style&index=0&id=4df6be3f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df6be3f"]])

export default __exports__